/* Decor Walay — money.js
   One money formatter for the whole theme.

   Mirrors Shopify's `money` Liquid filter using the store's own currency format
   (window.themeMoneyFormat, set in layout/theme.liquid from shop.money_format).
   Any price rendered by JS therefore comes out identical to the server-rendered
   one, so re-rendering the cart can never change the currency symbol.

     formatMoney(1299900)          -> "Rs.12,999.00"   (cents — /cart.js)
     formatMoneyFromAmount("1299.00") -> "Rs.1,299.00"  (decimal string — see below)
*/
(function () {
  'use strict';

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;
  var FALLBACK_FORMAT = 'Rs.{{amount}}';

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (precision == null) precision = 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (cents == null || isNaN(cents)) cents = 0;

    var parts = (cents / 100.0).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  /* cents -> formatted string, using the store's currency format */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9.-]/g, '');
    cents = parseFloat(cents);

    var formatString = format || window.themeMoneyFormat || FALLBACK_FORMAT;
    var match = formatString.match(PLACEHOLDER);
    var value;

    switch (match && match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(PLACEHOLDER, value);
  }

  /* The .json storefront endpoints (/products.json,
     /recommendations/products.json, /search/suggest.json) return prices as
     decimal strings like "1299.00", NOT cents like /cart.js does. */
  function formatMoneyFromAmount(amount, format) {
    var value = parseFloat(String(amount == null ? 0 : amount).replace(/[^0-9.-]/g, ''));
    if (isNaN(value)) value = 0;
    return formatMoney(Math.round(value * 100), format);
  }

  window.formatMoney = formatMoney;
  window.formatMoneyFromAmount = formatMoneyFromAmount;
})();
